import {WechatInitOptions, OpenCheckInDataType, WechatFileMsg} from "../../base/options";
import * as rp from "request-promise";
import {WechatService} from "../wechatservice";
import {TokenService} from "../../token/tokenservice";
import {CheckInTokenService} from "../../token/checkintokenservice";

/**
 * 企业微信 打卡 服务
 */
export class CheckInService {

  /*
   * 获取打卡数据
   * */
  static async getCheckInData(type: OpenCheckInDataType, startTime: number, endTime: number, userIdList: string[]): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new CheckInTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}checkin/getcheckindata?access_token=${accessToken}`,
      body: {
        "opencheckindatatype": type,
        "starttime": startTime,
        "endtime": endTime,
        "useridlist": userIdList
      },
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`get checkin data failed , response:`);
      console.error(result);
    }

    return "";
  }

}
